import { __rest } from "tslib";
import React from 'react';
import { useFormContext } from 'react-hook-form';
import Button from "../../../ui/CTA/Button";
const SubmitButton = (_a) => {
    var { children, shouldDisableWhenInvalid = false, shouldShowSpinner = false, actionType = 'primary', fullWidth = true, size = 'medium', disabled = false } = _a, props = __rest(_a, ["children", "shouldDisableWhenInvalid", "shouldShowSpinner", "actionType", "fullWidth", "size", "disabled"]);
    const { errors } = useFormContext();
    const isFormValid = Object.keys(errors).length === 0;
    const isDisabled = shouldShowSpinner || disabled || (shouldDisableWhenInvalid && !isFormValid);
    const defaultModifiers = {
        [actionType]: true,
        fullWidth,
        size,
    };
    return (React.createElement(Button, Object.assign({ shouldShowSpinner: shouldShowSpinner, "data-testid": "submitButton", disabled: isDisabled, type: "submit" }, defaultModifiers, props), children));
};
export default SubmitButton;
//# sourceMappingURL=SubmitButton.js.map